import styled from "styled-components";

export const AmusnetWidgetLabelDefaultBox = styled.span<{widgetWidth: number}>`
    position: relative;
    top: -1px;

    background: ${({theme}) => `linear-gradient(180deg, ${theme.colors.brandSecondary} 0%, ${theme.colors.brandPrimary} 100%)`};
    color: ${({theme}) => theme.colors.moneyColor};
    background-clip: text;
    color: transparent;
    font-size: ${({widgetWidth}) => widgetWidth * 11 / 130}px;
    padding-inline: 0.3rem;
    
    @media ${({theme}) => theme.mediaQuery.sAndAbove} {
        padding-inline: 0.5rem;
    }
    
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        font-size: ${({widgetWidth}) => widgetWidth * 19 / 240}px;
    }

    @media ${({theme}) => theme.mediaQuery.xxl} {
        top: 1px;
        line-height: 1.1;
        ${props => props.theme.font.presets.bold};
        padding-inline: 1.2rem;
    }
`;



